import PropTypes from "prop-types";
import React, { useState } from "react";

const Menu = (props) => {
  const { courseId, courses, setCourses } = props;

  const [openMenu, setOpenMenu] = useState(false);

  const deleteCourse = () => {
    fetch(`/courses/${courseId}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
    });

    setCourses(courses.filter((course) => course.id !== courseId));
  };

  return (
    <div>
      <div className="z-10 absolute right-0 flex flex-col">
        <button
          id="dropdownMenuIconButton"
          className="inline-flex items-center m-4 p-1 text-sm font-medium text-center text-gray-900 bg-primaryYellow hover:bg-gray-100 focus:outline-none"
          onClick={() => setOpenMenu(!openMenu)}
        >
          <svg
            className="size-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="white"
            viewBox="0 0 4 15"
          >
            <path d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
          </svg>
        </button>
      </div>

      {openMenu && (
        <div
          id="dropdownDots"
          className="z-10 absolute right-4 top-10 bg-white divide-y divide-gray-100 shadow-sm w-34"
        >
          <ul className="text-sm text-gray-700">
            <li>
              <a
                href={`/courses/${courseId}/edit`}
                className="block px-4 py-2 hover:bg-primaryYellow50"
              >
                Edytuj
              </a>
            </li>
            <li>
              <a
                href="#"
                className="block px-4 py-2 hover:bg-primaryYellow50"
                onClick={() => deleteCourse()}
              >
                Usuń
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

Menu.propTypes = {
  courseId: PropTypes.string,
  courses: PropTypes.arrayOf(PropTypes.object),
  setCourses: PropTypes.func,
};

export default Menu;
